import { combineReducers } from 'redux';
import {
  ContainerImageActionType,
  ContainerImageAction,
} from '../../actions/containerImageActions';

const loading = (state = false, action: ContainerImageAction) => {
  switch (action.type) {
    case ContainerImageActionType.GET_CONTAINER_IMAGES:
      return true;
    case ContainerImageActionType.GET_CONTAINER_IMAGES_OK:
    case ContainerImageActionType.GET_CONTAINER_IMAGES_ERROR:
      return false;
    default:
      return state;
  }
};

const error = (state = '', action: ContainerImageAction) => {
  switch (action.type) {
    case ContainerImageActionType.GET_CONTAINER_IMAGES:
      return '';
    case ContainerImageActionType.GET_CONTAINER_IMAGES_ERROR:
      return action.error;
    default:
      return state;
  }
};

export default combineReducers({ loading, error });
